export const NOTES_MODAL_SLICE_KEY = 'notesModal';
